import { BaseModal } from "../../../components/modalCommon/modalBase";
import { ModalHeader } from "../../../components/modalCommon/modalHeader";
import { ModalBody } from "../../../components/modalCommon/modalBody";
import { ModalFooter } from "../../../components/modalCommon/modalFooter";
import FormActionButton from "../../../components/formActionButton/formActionButton";
import { useI18n } from "../../../utils/translate/i18n/useI18n";

export default function AudiometerInfoModal({ open, onClose }: { open: boolean; onClose: () => void }) {
  const { t } = useI18n();

  return (
    <BaseModal open={open} onClose={onClose} size="md">
      <ModalHeader title={t("Jak korzystać z Audiometera")} onClose={onClose} />
      <ModalBody>
        <p className="mb-3">
          {t(
            "Użyj klawiszy strzałek, aby przesuwać kursor po wykresie, Enter lub Spacja, aby wstawić punkt. Klawisz L przełącza na ucho lewe, R lub P na ucho prawe."
          )}
        </p>
        <p className="mb-0">
          {t(
            "Przytrzymaj Ctrl lub Alt, aby odsłuchać dźwięk testowy w pozycji kursora. Tab przełącza między wykresami, a kliknięcie myszką przesuwa kursor."
          )}
        </p>
      </ModalBody>
      <ModalFooter>
        <FormActionButton
          type="button"
          variant="primary"
          fullWidth
          iconClassName="bi bi-check-circle"
          onClick={onClose}
        >
          {t("Zamknij")}
        </FormActionButton>
      </ModalFooter>
    </BaseModal>
  );
}
